import React from 'react';
import { faReply } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ReplyButton.module.css';
import { CommonButton } from '_components';


export class ReplyButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Reply'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faReply} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}
